/* eslint-disable */
import React, { Component } from 'react'
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Tutorial from '../../components/Tutorials/Tutorial'
import client from '../../Services/client'
import Card from '@material-ui/core/Card'

class TutorialList extends Component {

    state = {
        tutorial: [],
        searchString: ''
    }
    constructor() {
        super()
        this.getTutorial()
    }
    getTutorial = () => {
        client.getEntries({
            content_type: 'tutorial',
            query: this.state.searchString
        })
        .then((response) => {
            this.setState({tutorial: response.items})
            console.log(this.state.tutorial)
        })
        .catch((error) => {
          console.log("Error occurred while fetching Entries")
          console.error(error)
        })
    }
    onSearchInputChange = (event) => {
        console.log("Search changed ..." + event.target.value)
        if (event.target.value) {
            this.setState({searchString: event.target.value})
        } else {
            this.setState({searchString: ''})
        }
        this.getTutorial()
    }
    render() {
        return (
            <main className="listing-page">
                { this.state.tutorial ? (
                    <div>
                        <div className="listing-header">
                            <div>
                                <span className="listing-eyebrow">Learn and build</span>
                                <h1>Tutorials</h1>
                            </div>
                        <TextField className="listing-search"
                            id="searchInput"
                            placeholder="Search for Tutorials"   
                            margin="normal"
                            onChange={this.onSearchInputChange}
                            />
                        </div>
                        <Grid container spacing={3} className="listing-grid">
                            { this.state.tutorial.map(currentTutorial => (
                                <Grid item xs={12} sm={6} md={4} lg={3} key={currentTutorial.sys.id}>
                                    <Tutorial tutorial={currentTutorial} />
                                </Grid>
                            ))}
                        </Grid>
                    </div>
                ) : "No Tutorials found" }
            </main>
        )
    }
}

export default TutorialList;


// WEBPACK FOOTER //
// ./src/components/Tutorials/TutorialList.js